type StandardSeoOptions = {
  siteDescription: string;
  siteName: string;
  pageName: string;
  domain: string;
  image?: string | null;
  title: string;
  description: string;
  path: string;
  includeCanonical?: boolean;
  includeSchema?: boolean;
  includeOgTags?: boolean;
  ogLocale?: string;
};

export default function useStandardSeo(options: StandardSeoOptions) {
  const { includeCanonical = true, includeSchema = true, includeOgTags = true, ogLocale = 'nl_NL', ...rest } = options;

  useSeo({
    ...rest,
    includeCanonical,
    includeSchema,
    includeOgTags,
    ogLocale,
  });
}
